import React from 'react';
import { observer } from 'mobx-react-lite';
import { Div, Button, Typography } from '@icecreamsocial/components';

import {
	BusinessEcommerceForm,
	SteppedFormControls,
	Pagename,
} from '../../../../presentational';
import { useBusiness } from '../../../../providers/Business';

const ECommerce = ({ handleSubmit, returnTo, }) => {
	const { business } = useBusiness();
	const { data } = business;
	const { webstoreURL, eCommerceSolution } = data || {}
	return (
		<Div>
			<Pagename>eCommerce</Pagename>
			<BusinessEcommerceForm
				onSubmit={handleSubmit}
				allowRouteBlock={false}
				renderControls={() => <SteppedFormControls onNav={returnTo} />}
				{...{
					webstoreURL,
					eCommerceSolution
				}}
			/>
		</Div>
	);
};
ECommerce.displayName = 'BusinessSetUp.ECommerce';

export default observer(ECommerce);
